import React from 'react';
import PropTypes from 'prop-types';

export function DealerDetailsLogo(props) {
  const { logoUrl } = props;
  return (
    <div className="dealer-logo-wrapper">
      {logoUrl && (
        <div
          className="dealer-details-logo"
          style={{
            width: '144px',
            height: '64px',
          }}
        >
          <img
            className="dealer-details-logo-image"
            src={logoUrl}
            alt="dealer logo"
            style={{ maxHeight: '100%', maxWidth: '100%' }}
          />
        </div>
      )}
    </div>
  );
}

DealerDetailsLogo.propTypes = {
  logoUrl: PropTypes.string,
};

DealerDetailsLogo.defaultProps = {
  logoUrl: '',
};
